/** Base URL for the AI icon/logo generation service */
export const ICON_API = "https://ai-icon.b3.fun";
